export default (function () {
    document.querySelectorAll('[data-downloads-pagination]').forEach(form => {
        form.addEventListener('click', (e) => {
            const button = e.target.closest('[data-page-value]')
            if (!button) return

            const input = form.querySelector('[name^="cat_page"]')
            if (input) input.value = button.dataset.pageValue
        })
    })
})
